export default __webpack_public_path__ + "static/media/edit.91de0cee.svg";